import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=ebbe22ce&scoped=true&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=ebbe22ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbe22ce",
  null
  
)

export default component.exports